import { Stack } from '@mui/material';
import { CustomDrawer, type CustomDrawerPT, Input } from '../../components/index.ts';
import { Keyboard } from '@features/index.ts';
import { Button, IconButton } from '../../components/button/index.ts';
import { CrossIcon } from '../../assets/icons/cross.tsx';
import { CheckIcon } from '../../assets/icons/check.tsx';
import { useState } from 'react';
import { formatWithSymbol } from '../../assets/helpers/utils/index.ts';

type PT = {
  onPromoApplied: (code:string) => void;
} & CustomDrawerPT;

export const PromoDrawer = (props: PT) => {
  const { handleClose, onPromoApplied, ...rest } = props;
  const [code, setCode] = useState('');
  const onSubmit = () => {
    handleClose?.();
    onPromoApplied(code);
  }
  return (
    <CustomDrawer {...rest}>
      <Stack gap={22}>

        <Input
          value={formatWithSymbol(code, '-', 4, 'start')}
          placeholder={'Enter promo code'}
          sx={inputSx}
        />

        <Keyboard
          onClearButtonClick={() => {
            setCode(value => value.slice(0, value.length - 1));
          }}
          onKeyClick={(key) => {
            setCode(value => value + key);
          }}
        />


        <Stack direction={'row'} gap={8} alignItems={'center'}>
          <IconButton onClick={handleClose}>
            <CrossIcon />
          </IconButton>
          <Button fullWidth sx={{ alignItems: 'start', py: 10 }} onClick={onSubmit}>
            <Stack width="100%" direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
              Save promo code
              <CheckIcon />
            </Stack>
          </Button>
        </Stack>
      </Stack>

    </CustomDrawer>
  );
};

const inputSx = {
  'input': {
    textAlign: 'center',
  },
};